import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { TaxaAvulsa } from "@/models/taxa_avulsa";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

import { VUE_APP_SIT_API_URL, API_URL_SERVICE } from "@/commons/config";
import { map, catchError } from "rxjs/operators";
import GlobalStore from "@/store/modules/global";
import { throwError } from "rxjs";

export class TaxaAPI extends BaseAPI<TaxaAvulsa> {
  apiUrlOfficial: string = API_URL_SERVICE;

  constructor() {
    super();
    this.apiUrl = `${VUE_APP_SIT_API_URL}`;
  }

  public getAll(): AxiosObservable<TaxaAvulsa[]> {
    return this.axios.post(`${this.apiUrl}/boletos/getTaxas`, {}).pipe(
      map((response: any) => {
        return response.taxas;
      })
    );
  }

  public emitirTaxa(taxa: any): AxiosObservable<any> {
    if (taxa.placa) taxa.placa = taxa.placa.replace("-", "");

    return this.axios
      .post(`${this.apiUrlOfficial}/api/taxas-avulsas/`, taxa)
      .pipe(
        map((response: any) => {
          return response.extrato;
        })
      );
  }
}
